<template>
  <div>
    <v-form
      v-model="valid"
      ref="form"
      lazy-validation
      class="pr-md-24"
      @submit.prevent="updateSubcategory"
      v-if="subcategory && categories.length > 0"
    >
      <div class="d-flex justify-end mb-2">
        <v-btn
          tile
          color="primary"
          @click="$router.push({ name: 'subcategory-index' })"
        >
          <v-icon left>
            arrow_back
          </v-icon>
          Back
        </v-btn>
      </div>
      <v-card class="pr-md-24 pl-md-4 mb-10 pt-4" elevation="0" outlined>
        <v-container>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                :counter="35"
                outlined
                label="Name"
                v-model="subcategory.name"
                :rules="nameRules"
                hide-details="auto"
              ></v-text-field>
              <v-autocomplete
                v-model="subcategory.productCategoryId"
                :items="categories"
                outlined
                label="Select Category"
                item-text="name"
                item-value="id"
              ></v-autocomplete>
              <v-autocomplete
                v-model="subcategory.productSubCategoryTypeId"
                :items="subcategoryTypes"
                outlined
                label="Select Subcategory Type"
                item-text="name"
                item-value="id"
              ></v-autocomplete>
              <v-textarea
                :counter="200"
                outlined
                label="Description"
                :rules="descriptionRules"
                v-model="subcategory.description"
                hide-details="auto"
                required
              ></v-textarea>
            </v-col>
          </v-row>
          <div class="text-left pa-0 ma-0">
            <v-btn type="submit" color="accent" class="mx-0">Update</v-btn>
          </div>
        </v-container>
      </v-card>
    </v-form>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: ["id"],
  data() {
    return {
      valid: false,
      nameRules: [
        v => !!v || "Name is required",
        v => v.length >= 3 || "Name must be at least 3 characters",
        v => v.length <= 50 || "Name must be less than than 35 characters"
      ],
      descriptionRules: [
        v => !!v || "Description is required",
        v => v.length >= 10 || "Description must be at least 8 digits",
        v => v.length <= 200 || "Description must be less than than 20 digits"
      ]
    };
  },
  mounted() {
    this.$store.dispatch("subcategories/LOAD_SUBCATEGORY", {
      productSubcategoryId: this.id
    });
    this.$store.dispatch("categories/LOAD_CATEGORIES", {
      from: 0,
      to: 0
    });
    this.$store.dispatch("subcategorytypes/LOAD_SUBCATEGORY_TYPES", {
      from: 0,
      to: 0
    });
  },
  computed: {
    ...mapState({
      subcategory: state => state.subcategories.subcategory,
      categories: state => state.categories.categories,
      subcategoryTypes: state => state.subcategorytypes.subcategoryTypes
    })
  },
  methods: {
    async updateSubcategory() {
      if (this.$refs.form.validate()) {
        this.$swal({
          title: "Updating supplier...",
          html: "this will only take a moment...",
          icon: "info",
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch(
          "subcategories/UPDATE_SUBCATEGORY",
          this.subcategory
        );
        this.$swal.close();
        this.$swal({
          title: "Success",
          html: "Product subcategory has been updated",
          icon: "info"
        });
      }
    }
  }
};
</script>
